
import { get, get2, post, put, deletes } from "./http";

// 首页banner图
export const getBannerImg = params => get("/app/v2/home-page-banner", params);
export const getBannerImgEnglish = params => get("/app/en/home-page-banner", params);
// 关于百川-企业文化-企业价值观
export const getAboutCulturePrice = params => get("/app/v2/about-culture-price", params);
// 英文关于百川-企业文化-企业价值观
export const getEnglishAboutCulturePrice = params => get("/app/en/about-culture-price", params);

// 解决方案-碳减排-栏目一 type:91 & 栏目二 type:92
export const getSchemeColumn = id => get2("/app/v2/scheme-column", id);
// 解决方案-碳减排-栏目一 type:91 & 栏目二 type:92
export const getEnglishSchemeColumn = id => get2("/app/en/scheme-column", id);

// 解决方案-项目案例 type:94, 固废处理栏目 type:101, 固废处理项目案例 type:102
export const getSchemeProject = id => get2("/app/v2/scheme-project-case", id);
// 英文解决方案-项目案例 type:94, 固废处理栏目 type:101, 固废处理项目案例 type:102
export const getEnglishSchemeProject = id => get2("/app/en/scheme-project-case", id);
// 解决方案-售电服务 type:103
export const getSchemeSales = params => get("/app/v2/scheme-ele-sales-column", params);
// 英文解决方案-售电服务 type:103
export const getEnglishSchemeSales = params => get("/app/en/scheme-ele-sales-column", params);
// 加入我们-职业发展规划-栏目一&栏目二查询
export const getJoinUs = params => get("/app/v2/join-us-query", params);

// 加入我们-人才理念-员工福利查询
export const getEmployeeWelfare = params => get("/app/v2/join-us-employee-welfare-query", params);
// 解决方案-解决方案图片
export const getResolveImage = params => get("/app/v2/scheme-resolve-image", params);
// 英文解决方案-解决方案图片
export const getEnglishResolveImage = params => get("/app/en/scheme-resolve-image", params);
// 查询职位
export const getPositionList = params => get("/app/v2/position-list", params);
// 省市联动
export const getList = params => get("/app/v2/list", params);
export const getKLine = params => get("/app/v2/k-line", params);





// WEBPACK FOOTER //
// ./src/request/apiv2.js